import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > select {
    border: 1px solid var(--grey-25);
    padding: 20px 16px;
    border-radius: 8px;
    box-sizing: border-box;
    background: white;
    font-size: 16px;
    font-weight: var(--font-regular);
    font-family: inherit;
    color: var(--brand-secondary);
    line-height: 1;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    width: 100%;
    cursor: pointer;
  }

  & > svg {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    fill: var(--brand-secondary);
  }

  &:focus {
    outline: none;
    border-color: var(--brand-secondary);
  }

  label {
    font-size: 14px;
    cursor: pointer;
    width: 100%;
  }

  [type='radio'] {
    cursor: pointer;
    margin: 0 10px 0 0;
    width: 1.2em;
    height: 1.2em;
  }
`

export const Description = styled.p`
  font-weight: var(--font-regular);
`

export const RadioButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`
